import { render, staticRenderFns } from "./AbstractProfileTextInput.vue?vue&type=template&id=27f5cdf2&scoped=true&"
import script from "./AbstractProfileTextInput.vue?vue&type=script&lang=js&"
export * from "./AbstractProfileTextInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f5cdf2",
  null
  
)

export default component.exports